import React from "react";
import { Box } from "@mui/material";
import { dt } from "../../../shared/themes/redesignTokens";

// ═══════════════════════════════════════════════════════════════
//  MidasChatHeader
// ═══════════════════════════════════════════════════════════════

const MidasChatHeader: React.FC = () => {
  return (
    <Box
      sx={{
        height: "48px",
        display: "flex",
        alignItems: "center",
        padding: "0 16px",
        backgroundColor: dt.cardBg,
        borderBottom: `1px solid ${dt.cardBorder}`,
        flexShrink: 0,
        gap: "8px",
      }}
    >
      {/* Spacer */}
      <Box sx={{ flex: 1 }} />
    </Box>
  );
};

export default MidasChatHeader;
